// extracted by mini-css-extract-plugin
export default {"Form":"BookForm_Form__ADbdh","Stars":"BookForm_Stars__hv33Z","AddImage":"BookForm_AddImage__qsXYh"};